<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
    >
        <path
            d="M7.99 0.940002C7.17976 0.940002 6.40271 1.26187 5.82979 1.83479C5.25686 2.40771 4.935 3.18477 4.935 3.995C4.935 4.80524 5.25686 5.58229 5.82979 6.15521C6.40271 6.72814 7.17976 7.05 7.99 7.05C8.39119 7.05 8.78845 6.97098 9.1591 6.81745C9.52974 6.66393 9.86653 6.4389 10.1502 6.15521C10.4339 5.87153 10.6589 5.53475 10.8124 5.1641C10.966 4.79345 11.045 4.39619 11.045 3.995C11.045 3.59381 10.966 3.19655 10.8124 2.8259C10.6589 2.45525 10.4339 2.11847 10.1502 1.83479C9.86653 1.55111 9.52974 1.32608 9.1591 1.17255C8.78845 1.01902 8.39119 0.940002 7.99 0.940002Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.28 16.22C14.23 15.92 14.74 14.86 14.33 13.95C13.25 11.52 10.82 9.82001 7.99002 9.82001C5.16002 9.82001 2.73002 11.52 1.65002 13.95C1.24002 14.87 1.75001 15.92 2.70001 16.22C6.14302 17.3064 9.83701 17.3064 13.28 16.22Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
